import { registrationDetailsTsUtils } from '@/features/dashboard/tours/types/RegistrationDetails.ts.utils.ts';
import { RegistrationDetailDto } from '@/features/dashboard/tours/types/RegistrationDetailsDto.ts';
import { TriangleAlert } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/Tooltip.tsx';
import timeUtils from '@/utils/timeUtils.ts';
import { cn } from '@/lib/utils.ts';

const RegistrationDetailsCell = ({ dto }: { dto: RegistrationDetailDto }) => {
  const {
    registrationStatus,
    registrationBlocked,
    registrationStartDate,
    registrationEndDate,
    effectiveRegistrationEndDate,
  } = dto;

  // Backend wylicza rzeczywisty koniec zapisów także wtedy, gdy organizator nie
  // ustawił daty zamknięcia — wtedy granica wynika z dat wyjazdu i flagi „zapisy
  // w trakcie trwania", i warto o tym powiedzieć wprost.
  const endDateIsDerived = !registrationEndDate;
  const hasDates = registrationStartDate || effectiveRegistrationEndDate;

  const label = (
    <span
      className={cn(
        'max-w-full truncate',
        registrationDetailsTsUtils.getTextClass(registrationStatus),
      )}
    >
      {registrationDetailsTsUtils.getLabel(registrationStatus)}
    </span>
  );

  return (
    <div className="flex flex-row items-center justify-start gap-1">
      {hasDates ? (
        <Tooltip>
          <TooltipTrigger asChild>{label}</TooltipTrigger>
          <TooltipContent>
            <div className="flex flex-col gap-0.5">
              {registrationStartDate && (
                <span>
                  Od: {timeUtils.toDateTimeString(registrationStartDate)}
                </span>
              )}
              {effectiveRegistrationEndDate && (
                <span>
                  Do: {timeUtils.toDateTimeString(effectiveRegistrationEndDate)}
                  {endDateIsDerived && ' (wynika z terminu wyjazdu)'}
                </span>
              )}
            </div>
          </TooltipContent>
        </Tooltip>
      ) : (
        label
      )}

      {registrationBlocked ? (
        <Tooltip>
          <TooltipTrigger asChild>
            <TriangleAlert className="size-5 shrink-0 text-error-200" />
          </TooltipTrigger>
          <TooltipContent>
            Obóz ma skonfigurowaną datę otwarcia zapisów, ale nie został
            oznaczony jako gotowy. Aby rejestracja mogła zostać otwarta, obóz
            musi zostać aktywowany.
          </TooltipContent>
        </Tooltip>
      ) : null}
    </div>
  );
};

export default RegistrationDetailsCell;
